/* istanbul ignore file */

import { useState } from 'react';
const useMentorSuggestedSearch = ({
  useFindSuggestedMentor,
  studentId
}) => {
  const [query, setQuery] = useState('');
  const [selected, setSelected] = useState(null);
  const {
    data: suggestedMentor,
    isLoading: isLoadingSuggestedMentor,
    isSuccess: isSuccessSuggestedMentor,
    fetchStatus,
    status,
    error: suggestedMentorError
  } = useFindSuggestedMentor({
    userId: studentId,
    filters: {
      email: query
    }
  }, {
    enabled: Boolean(query)
  });
  const suggestedMentorFormatted = {
    id: suggestedMentor?.id,
    displayName: suggestedMentor?.displayName,
    subHeading: suggestedMentor?.email,
    avatar: suggestedMentor?.profilePicture
  };
  const total = suggestedMentor ? 1 : 0;
  const hasEmptyPeopleList = isSuccessSuggestedMentor && query === '' && total === 0;
  const errorCode = suggestedMentorError?.body.errors[0].code;
  return {
    status,
    fetchStatus,
    hasEmptyPeopleList,
    query,
    onQueryChange: setQuery,
    selected,
    onSelect: setSelected,
    isLoading: isLoadingSuggestedMentor,
    peopleList: suggestedMentor ? [suggestedMentorFormatted] : [],
    total,
    errorCode
  };
};
export default useMentorSuggestedSearch;